import Card from './components/card'
import Logo from './components/logo'
import Barcode from './components/barcode'
import Header from './components/header'
import HeroImage from './components/hero-image'
import Fields from './components/fields'
import GoogleIcons from './components/google-icons'
import GoogleAppLink from '/components/editor/google/fronts/components/app-link'

const GoogleEventFront = ({ show, backgroundColour, googleDarkBackgroundColour, fgColour }) => {
  return (
    <>
      <Card backgroundColour={backgroundColour} googleDarkBackgroundColour={googleDarkBackgroundColour} fgColour={fgColour}>
        <GoogleIcons show={show}/>
        <Logo />
        <div className="inset eventTicket">
          <Header />
        </div>
        <Barcode />
        <div className="inset">
          <Fields />
          <GoogleAppLink />
        </div>
      </Card>
      <HeroImage/>
    </>
  )
}


export default GoogleEventFront